import ToasterStore from '~store/ToasterStore';
import { alert, AlertTypes } from '~types/AlertTypes';

import SettlementCreatedToaster from './SettlementCreatedToaster';

interface PushSettlementCreatedToastParams {
  onViewSettlement: () => void;
  settlementName: string;
  toasterStore: ToasterStore;
}

export default function pushSettlementCreatedToast({
  onViewSettlement,
  settlementName,
  toasterStore,
}: PushSettlementCreatedToastParams) {
  toasterStore.push(
    alert(
      <SettlementCreatedToaster
        onClose={() => toasterStore.hidePermanentAlert()}
        onViewSettlement={onViewSettlement}
        settlementName={settlementName}
      />,
      AlertTypes.success,
      undefined,
      undefined,
      true,
      undefined,
      { vertical: 'bottom', horizontal: 'center' },
    ),
    true,
  );
}
